export default "__VITE_ASSET__9fe3807f__"